import { render, staticRenderFns } from "./DeliveryStatisticsTable.vue?vue&type=template&id=0dd4a427&scoped=true"
import script from "./DeliveryStatisticsTable.vue?vue&type=script&lang=js"
export * from "./DeliveryStatisticsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd4a427",
  null
  
)

export default component.exports